<div
    class="bg-th-blue mt-0 container-fluid h-menu-45  border-top-0 border-start-0 border-end-0 border-2 border-danger border-bottom">

    <div class=" d-flex justify-content-between align-content-center h-100 align-items-center">

        <div class="d-flex justify-content-center align-items-center">

            <i class="d-flex justify-content-center align-items-center 
                fa fa-power-off text-dark pointer rounded py-1 px-2 bg-white"
                style="font-size: 1.5em;height: 32px;width: 37px;" title="خروج از حساب کاربری"
                (click)="clickMethod('name')"></i>

            <i class="d-flex justify-content-center align-items-center 
                fa fa-rotate-right text-dark my-auto mx-2 pointer rounded py-1 px-2 bg-white"
                style="font-size: 1.2em;padding-top: 3px;height: 32px;width: 37px;font-size: 1.45rem;"
                title="به روز رسانی اطلاعات " (click)="reload()"></i>

            <ng-container *ngIf="!deviceInfo && !bDonotShowMap">

                <i class="d-flex justify-content-center align-items-center
                        fa fa-car pointer text-dark rounded py-1 px-2 bg-white"
                    style="font-size: 1.2em;padding-top:3px;height: 32px;width: 37px;margin-right: 8px;"
                    title="نمایش لیست خودروها " (click)="openMenuCar()"></i>

            </ng-container>

            <ng-container *ngIf="isHubEnabled && isHubConnect">
                <i class="fa d-flex justify-content-center align-items-center  text-dark my-auto pointer rounded py-1 px-2 bg-white"
                    style="font-size: 1.2em;padding-top: 3px;height: 32px;width: 37px;font-size: 1.45rem;"
                    [ngClass]="isLiveTracking ? 'fa-unlink' : 'fa-plug'"
                    [title]="isLiveTracking ? 'قطع کردن ردیابی زنده' : 'شروع ردیابی زنده'"
                    (click)="toggleLiveTracking()"></i>

            </ng-container>

        </div>

        <!-- logo | Hub Connection Status -->
        <div class="d-flex flex-row" *ngIf="deviceInfo">
            <ng-container *ngIf="isHubEnabled && !isHubConnect; else fleetyarLogo;">
                <ng-container *ngIf="isHubConnect == false;else recconectButton;">
                    <div class="loader-container">
                        <p class="mb-0"> ... قطع ارتباط با هاب سامانه، سعی بر برقراری مجدد ارتباط </p>
                        <div class="header-loader mx-2" aria-label="در حال بارگذاری"></div>
                    </div>
                </ng-container>
                <ng-template #recconectButton>
                    <button class="btn btn-warning" (click)="reConnectHub()">
                        اتصال به هاب
                    </button>
                </ng-template>
            </ng-container>
            <ng-template #fleetyarLogo>
                <img src="../../../assets/Img/fleetYar_Typo.png" width="140px">
            </ng-template>
        </div>

        <div class="d-flex flex-row ">
            <div class="d-flex align-items-center pointer hoverMenu rounded" (click)="openMenu()">
                <i class="fa fa-bars fa-lg" aria-hidden="true"></i>
            </div>
        </div>

    </div>

</div>

<div *ngIf="!bDonotShowMap" id="test" class="fixed-map-main">

    <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

    <div class="position-absolute" id="map_tooltips" data-bs-html="true"></div>

    <div class="fixed-area-choose">

        <div class=" px-3 rounded text-white index  position-absolute f14 pointer r60 d-flex flex-row  justify-content-between align-items-center"
            *ngIf=" deviceInfo && acssess.bEnableGeoFance">

            <i *ngIf="editMode" class="fa fa-pencil text-primary mx-2 fa-2x " title="ویرایش" (click)="editArea()"></i>

            <i class="fa fa-trash text-danger fa-2x ms-2 " title="حذف محدوده" (click)="deleteArea()"
                *ngIf=" deviceInfo && acssess.bDeleteGeoFance"></i>


            <select class="form-select " (change)="GeoFence($event.target) " id="areaSelection " [value]="GeoFenceId">

                <option value="-1 " class="text-center vazir ">انتخاب کنید</option>

                <option class="text-center vazir " *ngFor="let item of GeoFenceData " value="{{item.iGeoFence}} ">

                    {{item.strTitle}}</option>

            </select>

            <i class="fa fa-plus-circle fa-2x text-success me-1 " title="اضافه کردن محدوده"
                (click)="addInteraction()"></i>

        </div>

    </div>

    <div class="icon-Map position-absolute index d-flex flex-column ">

        <img src="../../../assets/Img/selectAll.png" title="نمایش همه خودروها در یک کادر " (click)="fitMap()"
            class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img">

        <div class="layers-container position-relative">
            <img src="../../../assets/Img/layer-icon.png" [class.guide-pulse]="showGuide"
                (click)="hasTrafficAccess ? toggleLayersContainer() :  changeTail()"
                class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img">
            <div class="guide-container" *ngIf="showGuide">
                از این قسمت می‌توانید نقشه ماهواره‌ای با دقت بالاتر را انتخاب کنید.
            </div>
            <!-- لایه های نقشه -->
            <ng-container *ngIf="hasTrafficAccess && bShowLayers">
                <div class="rounded position-absolute bg-white row gx-2 dir-rtl"
                    style="top: 0px;left:-240px;width: 228px;z-index: 2;">
                    <div *ngFor="let layer of mapLayers; let i = index" class="col-6 p-1 pointer"
                        [class.layer-disabled]="layer.disabled" (click)="changeTail(layer.id)">
                        <div class="rounded w-100 d-flex flex-column align-items-center justify-content-center p-1">
                            <div class="w-100" style="height: 53px;max-height: 53px;">
                                <img class="w-100 h-100"
                                    [ngClass]="iLayer.includes(layer.id) ? 'border border-2 border-warning' : ''"
                                    style="object-fit: cover;border-radius: 10px;" [src]="layer.imageUrl"
                                    [alt]="layer.name">
                            </div>
                            <span class="my-1" style="font-size: 14px;">{{ layer.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="bg-white position-absolute"
                    style="width: 20px;height: 20px;top: 11px;left:-28px;rotate: 48deg;z-index: 1;">
                </div>
            </ng-container>
        </div>

        <button *ngIf="deviceInfo && acssess.bPDF"
            class="p-2 circel-2 my-1 text-center pointer  icon-Img bg-third d-flex align-items-center justify-content-center border-0"
            [disabled]="exportPdf" (click)="exportPdfMap()">

            <i class="fa fa-file-pdf-o bold" title="خروجی pdf "></i>

        </button>

        <ng-container *ngIf="(!isHubEnabled && !isHubConnect) && (deviceInfo && acssess.bLive)">
            <button
                class="p-2 circel-2 my-1 text-center pointer  icon-Img bg-third d-flex align-items-center justify-content-center border-0">
                <a href="/tracker/trackAll" class="text-dark" target="_blank">
                    <i class="fa fa-car " title="نمایش بر خط همه خودرو ها"></i>
                </a>
            </button>
        </ng-container>
    </div>

</div>


<div class="position-fixed bg-secondary menu-bg" id="bg-menu" (click)="closeMenu()"></div>

<div *ngIf="bDonotShowMap" class="position-fixed bg-primary menu-bg">

    <img src="../../../assets/Img/wall-5.jpg" width="100%" height="100%" style="object-fit: cover;" alt="">

</div>

<!-- منوی مدیریت خمل و نقل  -->

<menu_item class="position-absolute bg-white col-xl-2 col-lg-3 col-md-4 col-8 h90 index-3 d-none"
    (tripModal)="tripModal($event)" (modalMenu)="showModal($event)">

</menu_item>

<!-- منوی پی سپار -->

<menu-peysepar class="position-absolute bg-white col-xl-2 col-lg-3 col-md-4 col-8 h90 index-3 d-none"
    (modalMenu)="showModal($event)" (holidayData)="holidayData($event)">

</menu-peysepar>

<!-- منوی اصلی برنامه -->

<menu_car class="position-absolute col-md-4 col-11  index-3" *ngIf="!bDonotShowMap" (carGroup)="filterCarMap($event)"
    (carIdOut)="showModal($event)" (locationTable)="addAlarmOnMap($event)" [item]="allCar" [dataWorkTa]="dataWorkTa"
    [dataWorkAz]="dataWorkAz" [GeoFence]="GeoFenceId" [dataPolygans]="datasabtPolygan">

</menu_car>

<!--Footer-->

<footer class="position-fixed footer w-100 bg-th-blue border-top border-danger border-2 index-footer">
    <div class="d-flex justify-content-around ">
        <div class="d-flex flex-row my-auto pointer index-2">
        </div>
        <div class="position-absolute sos">
            <button class="btn btn-danger circel " *ngIf="false && !deviceInfo && acssess.bEnableSOS"
                (mousedown)="handelSos()" (mouseup)="handelLeve()" (touchstart)="handelSos()"
                (touchend)="handelLeve()">SOS</button>
        </div>
        <div class="position-sticky " *ngIf="deviceInfo && acssess.bShowRayan">
            <a href="https://rayanandisheh.com" target="_blank" class="m-0 text-white text-shadow">
                {{appName | faNum}}
                {{version |faNum}}
            </a>
        </div>

        <div class="d-flex flex-column my-auto pointer index-2">

            <div id="mouse-position" class=""></div>


        </div>
    </div>
</footer>

<!-- ModalSaveCar -->

<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title d-flex align-content-center text-th-blue" id="exampleModalLabel">

                    <span class="ms-2">ثبت خودرو</span>

                    <i class="fa fa-question-circle fa-2x pointer" (click)="guid()"></i>

                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex flex-column flex-md-row justify-content-center align-items-center"
                [formGroup]="datasabt" *ngIf=" acssess.bEnableAddCar">

                <!-- ثبت خودرو با ردیاب -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column"
                    *ngIf=" acssess.bAddGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault1">

                        <img src="../../../assets/Img/car-gps.png" height="80px">

                        <span>ثبت خودرو با ردیاب</span>

                    </label>

                    <input class="form-check-input" type="radio" id="flexRadioDefault1" value="1" formControlName="gps">

                </div>

                <!-- خودرو اداری  -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column"
                    *ngIf=" acssess.bAddGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault3">

                        <div style="height: 80px;" class="d-flex justify-content-center align-items-center">

                            <img src="../../../assets/Img/car-office.png" height="60px">

                        </div>

                        <span>ثبت خودرو اداری</span>

                    </label>

                    <input class="form-check-input" type="radio" id="flexRadioDefault3" value="3" formControlName="gps">

                </div>

                <!-- ثبت خودرو بدون ردیاب -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column"
                    *ngIf=" acssess.bAddNGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault2">

                        <img src="../../../assets/Img/car-no-gps.png" height="80px">

                        <span>ثبت خودرو بدون ردیاب</span>

                    </label>

                    <input class="form-check-input" type="radio" value="2" id="flexRadioDefault2" formControlName="gps">

                </div>


            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-success" (click)="sabt()">

                    تایید

                    <i class="fa fa-angle-double-down"></i>

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                    <i class="fa fa-close"></i>

                </button>

            </div>

        </div>

    </div>

</div>

<!-- Modal Menu-->

<div class="modal fade rtl " id="menuModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel">{{modalMenuTitle}}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around">

                <!-- از تاریخ -->

                <ng-container
                    *ngIf="(menuModalId >= 1 && menuModalId <= 7) || (menuModalId >= 18 && menuModalId <= 19)">

                    <form [formGroup]="dataPeriodAz" class="me-3">

                        <label> از تاریخ </label>

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </ng-container>

                <!-- تا تاریخ -->

                <form [formGroup]="dataPeriodTa">

                    <label>تا تاریخ</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                        [dateFormat]="'jYYYY/jMM/jDD'">

                        <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-success" (click)="report(menuModalId)">

                    تایید

                    <i class="fa fa-angle-double-down"></i>

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                    <i class="fa fa-close"></i>

                </button>

            </div>

        </div>

    </div>

</div>

<!-- Modal Move In Area-->

<div class="modal fade rtl " id="carMoveAreaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">انتخاب تاریخ</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="col-11 mx-auto">
                    <label class="mb-2"> تاریخ *</label>
                    <form [formGroup]="datasabtPolygan">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>
                </div>



            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" id="enterAnimateArea">تایید <i
                        class="fa fa-angle-double-down"></i> </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>

<!-- Modal analysis -->

<div class="modal fade dirI" style="z-index: 99999;" id="modalPolygan" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- <button class="btn btn-primary" id="moveinArea" data-bs-toggle="modal" data-bs-target="#menuModal" (click)="hideTooltip()">حرکت داخل محدوده </button> -->

                <!-- <button class="btn btn-success" id="analysisArea" name="analysis" *ngIf="deviceInfo && acssess.bAnalysDomain">تحلیل در محدوده </button> -->

                <!-- <button class="btn btn-warning" id="enterExit" name="analysis">ورود و خروج </button> -->
                <!-- <button class="btn btn-info" id="">تخلف ورود </button>
                <button class="btn btn-danger" id=""> تخلف خروج </button> -->
                <div class="reportsView">
                    <button class="btn btn-th-blue w-200 mt-2" id="moveinArea" data-bs-toggle="modal"
                        data-bs-target="#menuModal" (click)="hideTooltip()">حرکت داخل محدوده <i
                            class="fa fa-street-view" aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2" id="analysisArea" name="analysis"
                        *ngIf="deviceInfo && acssess.bAnalysDomain">تحلیل در محدوده <i class="fa fa-map"
                            aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2" id="enterExit" name="analysis">ورود و خروج <i
                            class="fa fa-external-link" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف ورود <i class="fa fa-sign-out"
                            aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف خروج <i class="fa fa-sign-in"
                            aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>

<!--Save Poygan-->

<div class="modal fade rtl " id="savePolygan" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">ثبت محدوده</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="col-11 mx-auto">
                    <label class="">نام محدوده</label>
                    <input [formControl]="polyganName" class="form-control">
                </div>



            </div>

            <div class="modal-footer">

                <button *ngIf="!editMode" type="button" class="btn btn-success" (click)="savePolygon()">ثبت <i
                        class="fa fa-angle-double-down"></i> </button>

                <button *ngIf="editMode" type="button" class="btn btn-primary" (click)="submitEditedTitle()"> ویرایش <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-danger " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>

            </div>

        </div>

    </div>

</div>

<!--Report analysis-->

<div class="modal fade rtl " id="exampleModalreportArea" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-5 mb-2">
                    <label class="mb-2">از تاریخ* </label>
                    <form [formGroup]="dataWorkAz">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class="col-5 mb-2">
                    <label class="mb-2"> تا تاریخ *</label>
                    <form [formGroup]="dataWorkTa">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>

                <div class=" col-5">
                    <label class="mb-2"> از ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="00:00" id="clocks" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>


                </div>
                <div class=" col-5">
                    <label class="mb-2"> تا ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="23:59" id="clocke" readonly>
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>

                </div>



            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" id="reporetArea">تایید <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>

<!--Exel Uploder-->

<div class="modal fade" id="exelUploder" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">ورود ساعت کارکرد خودروها </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <input type="file" class="d-none" id="fileupload" accept=".xlsx" (change)="fileChange($event)">
                <button class="btn btn-success " (click)="openUploder()">بارگذاری اکسل</button>
            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن </button>
                <button type="button" class="btn btn-primary" (click)="saveFile()">ذخیره</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal-Help -->

<div class="modal fade" id="help-Modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title bold txt-navy">راهنمای {{ webAppName }} </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body overflow-auto" style="max-height: 50vh;">
                <div class="d-flex flex-column justify-content-center">
                    <a class="text-start my-1 text-dark pointer" *ngFor="let item of helpData;let i=index"
                        href="{{item.strURL}}" target="_blank">
                        {{i+1}}-
                        <img src="../../../assets/Img/free-movie-icon-850-thumb.png" width="40px" height="40px"
                            *ngIf="item.tiType==1">
                        <img src="../../../assets/Img/PDF_file_icon.svg.png" width="40px" height="50px"
                            *ngIf="item.tiType==2">
                        {{item.strTitle}}
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- PEYSEPAR LANDING MODALS -->

<!-- Modal Holidays -->

<div class="modal fade rtl " id="holidaysModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title d-flex align-content-center text-dark" id="exampleModalLabel"> <span
                        class="ms-2">ثبت و ویرایش تعطیلات</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-12 d-flex flex-wrap justify-content-between m-1">
                    <div class="d-flex col-md-3 col-6  dirI form-group">
                        <span class="mt-2 me-2">سال: </span>
                        <select class="form-select col-auto pointer" id="holidayYear"
                            (change)="changeHolidayYear($event.target.value)">
                            <option *ngFor="let item of holidaySelection" value="{{item}}">{{item | faNum}}</option>
                        </select>
                    </div>
                    <div class="col-md-2 col-6  dirI">
                        <button class="btn btn-outline-success" style="width: 100px;" (click)="setNewHolidayModal()">ثبت
                            &nbsp;<i class="fa fa-plus "></i></button>
                    </div>
                </div>
                <div class="p-1" *ngIf="holidays?.length > 0">
                    <table class="table table-striped dirI">
                        <thead class="">
                            <tr class="text-center">
                                <th scope="col" class=""># </th>
                                <th scope="col" class="">تاریخ</th>
                                <th scope="col" class="">روز</th>
                                <th scope="col" class="">نوع</th>
                                <th scope="col" class="">توضیحات</th>
                                <th scope="col" class=""></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f14" *ngFor="let item of holidays;let i=index">
                                <th class="text-dark">{{i+1 | faNum}}</th>
                                <th class="text-dark">{{item.strDate | faNum}}</th>
                                <th class="text-dark">{{item.strDayName | faNum}}</th>
                                <th class="text-dark">{{item.strTypeComment | faNum}}</th>
                                <th class="text-dark">{{item.strComment | faNum}}</th>
                                <th class="text-dark"><i (click)="deleteHoliday(item)"
                                        class="fa fa-trash fa-lg text-danger pointer"></i></th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="holidays?.length < 1" class="d-flex justify-content-center align-items-center">
                    <span class="fw-bold text-dark f18">موردی یافت نشد</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>

<!-- Modal add holiday -->

<div class="modal fade" id="addHolidayModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title bold txt-navy">ثبت تعطیلی جدید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="d-flex justify-content-between">
                    <div class="col-md-4 col-6 ">
                        <label>تاریخ</label>
                        <form [formGroup]="datasabt">
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                <input type="text" formControlName="date" class="form-control shadow text-end"
                                    readonly />
                            </ng-persian-datepicker>
                        </form>
                    </div>
                    <div class="col-md-4 col-6 ">
                        <label>نوع</label>
                        <select class="form-select col-auto pointer" id="holidayType">
                            <option value="0">رسمی</option>
                            <option value="1">آلودگی هوا</option>
                            <option value="2">سایر</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <textarea class="form-control" id="holidayComment" rows="3" placeholder="توضیحات..."></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="saveHoliday()">ذخیره <i class="fa fa-check"></i>
                </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>

            </div>
        </div>
    </div>
</div>

<!-- Trip Modal -->

<div class="modal fade" id="tripModal" tabindex="-1" role="dialog" aria-labelledby="tripModalLabel" aria-hidden="true"
    style="z-index: 100000;">

    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="tripModalLabel"> ثبت سفر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <ng-container *ngIf="bShowTripComp">

                    <app-trips [appMenuType]="-1" (tripModal_Close)="tripModal(false)"> </app-trips>

                </ng-container>

            </div>

        </div>

    </div>

</div>

<!-- expired cars component -->

<div class="modal fade" id="expiredCars_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> تمدید اعتبار خودروها </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body p-0 m-0">

                <ng-container *ngIf="bExpiredComp">

                    <app-vehicle-renewal [isCalled]="true"></app-vehicle-renewal>

                </ng-container>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>